const formParamNotificationWebhook = {
  deleteWebhook: 'Deletar Webhook',
  deleteWebhookMessage: 'Deseja realmente deletar o webhook?',
  subtitle: 'Webhooks são utilizados para permitir a comunicação entre duas aplicações e enviar notificações quase em tempo real.',
  invalidUrl: 'URL inválida',
  showActionsLabel: 'Ativar notificações de ações',
  actionsHelperText: 'As notificações de Ações incluem: criação, edição, mudança de status e deleção.',
  actionsHelperText2: 'Estas serão enviadas com uma requisição POST para {url}(ex: https://geequip.sistemasgap.com.br/actions)',
  showServicesLabel: 'Ativar notificações de serviços',
  servicesHelperText: 'As notificações de Serviços incluem: criação, edição e deleção.',
  servicesHelperText2: 'Estas serão enviadas com uma requisição POST para {url}(ex: https://geequip.sistemasgap.com.br/services)',
  createWebhook: 'Criar Webhook',
  active: 'Ativo',
  apiKeyHelperText: 'Os payloads entregues a sua url irão conter o header: {"x-api-key": {suaApiKey}}',
};

export default formParamNotificationWebhook;
